import {
  EnvironmentOutlined,
  LockOutlined,
  LogoutOutlined,
  ShoppingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { Link, useLocation } from "react-router-dom";

import { ACCOUNT_NAV_ITEMS, ROUTES } from "@/constants";

interface AccountNavMenuProps {
  mobile?: boolean;
  onLogout: () => void;
}

const ACCOUNT_NAV_ICONS = {
  profile: <UserOutlined />,
  addresses: <EnvironmentOutlined />,
  orders: <ShoppingOutlined />,
  security: <LockOutlined />,
} as const;

const resolveActiveKey = (pathname: string) => {
  if (pathname.startsWith(ROUTES.ACCOUNT_ADDRESSES)) {
    return "addresses";
  }

  if (pathname.startsWith(ROUTES.ACCOUNT_ORDERS)) {
    return "orders";
  }

  if (pathname.startsWith(ROUTES.ACCOUNT_SECURITY)) {
    return "security";
  }

  return "profile";
};

export const AccountNavMenu = ({
  mobile = false,
  onLogout,
}: AccountNavMenuProps) => {
  const location = useLocation();
  const activeKey = resolveActiveKey(location.pathname);

  return (
    <div className={mobile ? "account-nav account-nav--mobile" : "account-nav"}>
      <div className="account-nav__items">
        {ACCOUNT_NAV_ITEMS.map((item) => {
          const isActive = item.key === activeKey;

          return (
            <Link
              key={item.key}
              className={`account-nav__link${isActive ? " is-active" : ""}`}
              to={item.path}
            >
              <span className="account-nav__icon">
                {ACCOUNT_NAV_ICONS[item.key]}
              </span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>

      <Button
        className="account-nav__logout"
        danger={!mobile}
        icon={<LogoutOutlined />}
        onClick={onLogout}
        type={mobile ? "default" : "text"}
      >
        Đăng xuất
      </Button>
    </div>
  );
};
